import React, { Component } from 'react';
import {monthNames} from '../helpers/Common';
import * as Config from '../config/Config';
   
export default class Footer extends Component {

	render() {
		let monthNames = monthNames;
			let d=new Date(), jYear=d.getFullYear();
		return (
			<footer>
				<span>Copyright &copy; 2017-{jYear},</span>
				<span>Threesixtyone Degree Minds Consulting Pvt Ltd.</span>
				<span>All Rights Reserved.</span>
				<span className="f-lnk"><a href={`${Config.rootDomainUrl}about-us/privacy.php`} target="_blank" rel="noopener noreferrer">Privacy</a>&nbsp;&nbsp;|&nbsp;&nbsp;<a href={`${Config.rootDomainUrl}about-us/legal.php`} target="_blank" rel="noopener noreferrer">Legal</a></span>
			</footer>
		);
	}
}



// WEBPACK FOOTER //
// ./src/partials/Footer.js